export default {
  CMS_ROLE_REDIRECT: true,
  CMS_ROLES: ['Retail Marketer', 'Wholesale Marketer'],
}



// WEBPACK FOOTER //
// ./src/lib/roleConstants.js